/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Q_Ozellik_TalebiInputs */

const tr_faq_q_ozellik_talebi = /** @type {(inputs: Faq_Q_Ozellik_TalebiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Özellik talebi nereye iletilir?`)
};

const en_faq_q_ozellik_talebi = /** @type {(inputs: Faq_Q_Ozellik_TalebiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How do I request a new feature?`)
};

const de_faq_q_ozellik_talebi = /** @type {(inputs: Faq_Q_Ozellik_TalebiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie beantrage ich eine neue Funktion?`)
};

const ru_faq_q_ozellik_talebi = /** @type {(inputs: Faq_Q_Ozellik_TalebiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Как запросить новую функцию?`)
};

/**
* | output |
* | --- |
* | "How do I request a new feature?" |
*
* @param {Faq_Q_Ozellik_TalebiInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const faq_q_ozellik_talebi = /** @type {((inputs?: Faq_Q_Ozellik_TalebiInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Q_Ozellik_TalebiInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_faq_q_ozellik_talebi(inputs)
	if (locale === "de") return de_faq_q_ozellik_talebi(inputs)
	if (locale === "ru") return ru_faq_q_ozellik_talebi(inputs)
	return tr_faq_q_ozellik_talebi(inputs)
});